export default __webpack_public_path__ + "static/media/pending-not-selected.d6b77a94.svg";